import { BaseRepository } from "repositories/BaseRepository";

export class FilesRepository extends BaseRepository {
  constructor(db) {
    super(db, "files");
  }

  async getByEntity(scope, entity, entityId) {
    const result = await this.where("by_scope_entity").eq([scope, entity, entityId]);
    if (result && Array.isArray(result) && result[0]) {
      const [file] = result;
      return file;
    }

    return null;
  }

  isExpired(file) {
    if (!file.cachedAt || !file.ttl) return false;
    return Date.now() - file.cachedAt > file.ttl;
  }
}
